<template>
  <div>
    <div v-for="(item, index) in items" :key="index" class="chatSettingMenuItem" :class="item.type" @click="item.method">
      <span>{{item.alt}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'items'
  ]
}
</script>

<style lang="scss">
/*.chatSettingMenuItem span {*/
  /*letter-spacing: normal;*/
  /*display: none;*/
  /*position: absolute;*/
  /*padding: 0 5px;*/
  /*height: 21px;*/
  /*line-height: 21px;*/
  /*white-space: nowrap;*/
  /*border: 1px solid #000;*/
  /*background-color: #ffffe1;*/
  /*color: #000;*/
  /*z-index: 10;*/
  /*user-select: none;*/
  /*font-size: 12px;*/
/*}*/
/*.chatSettingMenuItem:hover span {*/
  /*display: block;*/
/*}*/
/*#chatSettingMenuItemContainer .chatSettingMenuItem span {*/
  /*top: 5px;*/
  /*left: 30px;*/
/*}*/
/*#chatAdminRemoteController .chatSettingMenuItem span {*/
  /*top: 30px;*/
  /*left: 0px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// chat-setting-menu-item.vue?b2d67ec4